import { MapPin, Phone, Mail, MessageCircle } from "lucide-react";
import { CONTACT } from "../data/content";
import { FadeUp, SectionHead } from "./Reveal";
import { useEnquiry } from "./EnquiryContext";

export const Contact = () => {
  const { openEnquiry } = useEnquiry();
  return (
    <section id="contact" data-testid="contact-section" className="relative py-24 lg:py-36 bg-forest-900/40">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-20">
          <div>
            <SectionHead
              num="10"
              eyebrow="Contact"
              title="Let's Plan Your Next Journey"
            />
            <FadeUp delay={0.2}>
              <div className="mt-10 space-y-7">
                <div className="flex items-start gap-4">
                  <MapPin size={18} className="text-gold mt-1 shrink-0" strokeWidth={1.5} />
                  <div>
                    <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-fog block mb-1.5">
                      Registered Office
                    </span>
                    <p className="text-sm text-cream/80 leading-relaxed max-w-sm">
                      HIDDENBIOMES LLP · {CONTACT.address}
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <Phone size={18} className="text-gold mt-1 shrink-0" strokeWidth={1.5} />
                  <div>
                    <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-fog block mb-1.5">
                      Call Us
                    </span>
                    <a href={`tel:${CONTACT.phoneRaw}`} className="text-sm text-cream/80 hover:text-gold transition-colors">
                      {CONTACT.phone}
                    </a>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <Mail size={18} className="text-gold mt-1 shrink-0" strokeWidth={1.5} />
                  <div>
                    <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-fog block mb-1.5">
                      Write to Us
                    </span>
                    <a href={`mailto:${CONTACT.email}`} className="text-sm text-cream/80 hover:text-gold transition-colors">
                      {CONTACT.email}
                    </a>
                  </div>
                </div>
              </div>
            </FadeUp>
            <FadeUp delay={0.3}>
              <div className="mt-10 flex flex-wrap gap-4">
                <a
                  href={`tel:${CONTACT.phoneRaw}`}
                  data-testid="contact-call-btn"
                  className="bg-gold text-forest-950 font-mono text-[11px] uppercase tracking-[0.2em] px-7 py-3.5 hover:bg-cream transition-colors duration-300"
                >
                  Call Now
                </a>
                <a
                  href={CONTACT.whatsapp}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="contact-whatsapp-btn"
                  className="flex items-center gap-2 border border-gold/40 text-gold font-mono text-[11px] uppercase tracking-[0.2em] px-7 py-3.5 hover:bg-gold hover:text-forest-950 transition-colors duration-300"
                >
                  <MessageCircle size={14} /> WhatsApp
                </a>
                <button
                  data-testid="contact-enquiry-btn"
                  onClick={() => openEnquiry()}
                  className="border border-cream/25 text-cream/80 font-mono text-[11px] uppercase tracking-[0.2em] px-7 py-3.5 hover:border-gold hover:text-gold transition-colors duration-300"
                >
                  Send Enquiry
                </button>
              </div>
            </FadeUp>
          </div>

          <FadeUp delay={0.15}>
            <div
              data-testid="contact-map"
              className="relative h-[380px] lg:h-full min-h-[380px] border border-gold/15 overflow-hidden"
            >
              <iframe
                title="HIDDENBIOMES LLP Registered Office — Indore"
                src={CONTACT.mapEmbed}
                className="w-full h-full"
                style={{ border: 0, filter: "grayscale(0.6) invert(0.92) hue-rotate(180deg) contrast(0.9)" }}
                loading="lazy"
                allowFullScreen
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </FadeUp>
        </div>
      </div>
    </section>
  );
};
